import { Middleware, MiddlewareAPI, isRejectedWithValue } from "@reduxjs/toolkit";

const TokenMiddleware: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
        console.warn('TokenMiddleware: action rejected with value', action);
        if ((action.payload as any).status === 401) {
            console.warn('TokenMiddleware: token is invalid, redirecting to login');
            // get the storefront & organization from the URL
            const url = new URL(window.location.href);
            // Get organization & storefront from local storage
            const organization = localStorage.getItem('organization');
            const storefront = localStorage.getItem('storefront');
            // redirect to login
            if (organization == null && storefront == null) {
                window.location.href = `/login`;
            } else {
                const message = 'Your session has expired. Please log in again.'
                window.location.href = `/${organization}/${storefront}/login?message=${encodeURIComponent(message)}&redirect=${encodeURIComponent(window.location.pathname)}`;
            }
        } else {
            console.warn('TokenMiddleware: action rejected with value', action.error);
        }
    }
    return next(action);
}


export default TokenMiddleware;